const standaloneRoutes = [
    '/pdf',
    '/responder-cotacao',
    '/criar-senha',
    '/indicacao/',
];

export function isStandaloneRoute(pathname: string) {
    return standaloneRoutes.some((route) => pathname.includes(route));
}